class StickyHeader extends window.HTMLElement {
  connectedCallback() {
    this.header = document.getElementById("shopify-section-header");
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.scrollThreshold = 100;
    this.directionChangeY = 0;
    this.lastDirection = null;
    this.originalNavHeight = "";
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };
    requestAnimationFrame(() => {
      this.originalNavHeight = getComputedStyle(document.documentElement).getPropertyValue("--height-nav").trim();
    });
    window.addEventListener("scroll", this.onScrollHandler, false);
    this.createObserver();
  }
  createObserver() {
    const observer = new window.IntersectionObserver((entries, observer2) => {
      this.headerBounds = entries[0].boundingClientRect;
      observer2.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    const direction = scrollTop > this.currentScrollTop ? "down" : "up";
    if (direction !== this.lastDirection) {
      this.directionChangeY = this.currentScrollTop;
      this.lastDirection = direction;
    }
    const scrolledSinceChange = Math.abs(scrollTop - this.directionChangeY);
    if (direction === "down" && scrollTop > 150) {
      if (this.preventHide) return;
      if (scrolledSinceChange >= this.scrollThreshold) {
        window.requestAnimationFrame(this.hide.bind(this));
      }
    } else if (direction === "up" && scrollTop > 150) {
      if (scrolledSinceChange >= this.scrollThreshold) {
        if (!this.preventReveal) {
          window.requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          window.requestAnimationFrame(this.hide.bind(this));
        }
      }
    } else if (scrollTop <= this.headerBounds.top) {
      window.requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    document.documentElement.style.setProperty("--height-nav", "1rem");
    if (!this.header.classList.contains("sticky")) {
      this.header.classList.add("sticky", "top-0", "-translate-y-full");
      void this.header.offsetHeight;
      requestAnimationFrame(() => {
        this.header.classList.add("transition-transform");
      });
    } else {
      this.header.classList.add("-translate-y-full");
    }
  }
  reveal() {
    document.documentElement.style.setProperty(
      "--height-nav",
      this.originalNavHeight
    );
    this.header.classList.add("sticky", "top-0", "transition-transform");
    this.header.classList.remove("-translate-y-full");
  }
  reset() {
    document.documentElement.style.setProperty(
      "--height-nav",
      this.originalNavHeight
    );
    this.header.classList.remove(
      "-translate-y-full",
      "sticky",
      "top-0",
      "transition-transform"
    );
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler, false);
  }
}
window.customElements.define("sticky-header", StickyHeader);
